import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, flatMap } from 'rxjs/operators';
import { LayoutConfigService, SplashScreenService, TranslationService } from '../metronic/core/_base/layout';
import { locale as enLang } from '../metronic/core/_config/i18n/en';
import { locale as plLang } from '../metronic/core/_config/i18n/pl';
import { locale as ruLang } from '../metronic/core/_config/i18n/ru';
import { locale as ukLang } from '../metronic/core/_config/i18n/uk';
import { AppRouteNames } from './app-paths.constants';


@Component({
  selector: 'rek-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  loader: boolean;

  private unsubscribe: Subscription[] = [];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translationService: TranslationService,
    private layoutConfigService: LayoutConfigService,
    private splashScreenService: SplashScreenService
  ) {
    // register translations
    this.translationService.loadTranslations(enLang, plLang, ruLang, ukLang);
  }

  ngOnInit() {
    this.initializeTitleService();
    this.initializeMetronic();
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(sb => sb.unsubscribe());
  }


  private initializeTitleService(): void {
    const subscribtion = this.router
      .events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        flatMap(() => {
          let child = this.activatedRoute.firstChild;

          while (child.firstChild) {
            child = child.firstChild;
          }

          return this.translationService.getTranslationFor([child.snapshot.data.Title, 'PAGE.TITLE-SUFFIX']);
        })
      )
      .subscribe((translations: string) => {
        const pageTitleKey = Object.keys(translations)[0];
        const pageTitleSuffixKey = Object.keys(translations)[1];

        const pageTitle = translations[pageTitleKey] || '¯\\_( ツ )_/¯';
        const pageTitleSuffix = translations[pageTitleSuffixKey];

        this.titleService.setTitle(`${pageTitle} | ${pageTitleSuffix}`);
      });

    this.unsubscribe.push(subscribtion);
  }


  private initializeMetronic(): void {
    this.loader = this.layoutConfigService.getConfig('loader.enabled');

    const routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.splashScreenService.hide();

        // scroll to top on every route change (but not in dashboard)
        if (!event.url.includes(AppRouteNames.App.Dashboard.Root)) {
          window.scrollTo(0, 0);
        }

        // display back the body content after splash screen
        setTimeout(() => {
          document.body.classList.add('kt-page--loaded');
        }, 500);
      }
    });

    this.unsubscribe.push(routerSubscription);
  }
}
